import { useSyncExternalStore } from "react";

import { isOnlineNow, subscribeToOnlineStatus } from "../../offline/connectivity";

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribeToOnlineStatus, isOnlineNow, () => true);
}
